import api from '@sparemin/api-sdk';
import { normalize } from 'normalizr';
import {
  Response,
  SuperAgent,
  SuperAgentRequest,
  SuperAgentStatic,
} from 'superagent';
import { SPAREMIN_SERVICES_EMBEDCONFIGURATION_URL } from 'config';
import { createRequest } from '../utils';
import { lockSpecSchema } from './schemas';
import * as types from './types';

function createConfiguration(
  args: types.CreateConfigurationArgs,
  request: SuperAgentStatic,
): Promise<types.CreateConfigurationResult> {
  const {
    durationMillis: expectedDurationMilli,
    slides: slideshowInfo,
    textOverlayInfo,
    audioInfo,
    videoClips,
    versionInfo,
    recordingId,
    dimensions,
    soundwave,
    watermark,
    captions,
    creatorUserId,
    layers: layerOrder,
    lockSpec,
    mainMediaContainer,
    mediaSegmentInfo,
    progress,
    timer,
    edgeVideos,
  } = args;

  const hideAvatars = true;
  const bigPlay = false;
  const theme = 'light';

  return request
    .post('/api/v1/embed-configuration')
    .send({
      audioInfo,
      bigPlay,
      captions,
      creatorUserId,
      dimensions,
      edgeVideos,
      expectedDurationMilli,
      hideAvatars,
      layerOrder,
      lockSpec,
      mainMediaContainer,
      mediaSegmentInfo,
      progress,
      recordingId,
      slideshowInfo,
      soundwave,
      textOverlayInfo,
      theme,
      timer,
      versionInfo,
      videoClips,
      watermark,
      templateId: 6,
    })
    .then((res: Response) => ({
      configuration: res.body,
    }));
}

function getConfiguration(
  args: types.GetConfigurationArgs,
  request: SuperAgent<SuperAgentRequest>,
): Promise<types.GetConfigurationResult> {
  const [wid] = args;

  return request.get(`/api/v1/embed-configuration/${wid}`).then(res => ({
    configuration: res.body,
  }));
}

async function getLockSpec(
  args: types.GetLockSpecArgs,
): Promise<types.GetLockSpecResult> {
  const result = await api.getLockSpec(args);
  return normalize(result, lockSpecSchema);
}

export const handle: types.IHandle = (
  method: any,
  args: any,
  token?: string,
): any => {
  const request = createRequest({
    token,
    baseUrl: SPAREMIN_SERVICES_EMBEDCONFIGURATION_URL,
    omitBearerPrefix: true,
  });

  switch (method) {
    case types.ServiceMethod.CREATE_CONFIGURATION:
      return createConfiguration(
        args as types.CreateConfigurationArgs,
        request,
      );

    case types.ServiceMethod.GET_CONFIGURATION:
      return getConfiguration(args as types.GetConfigurationArgs, request);

    case types.ServiceMethod.GET_LOCK_SPEC:
      return getLockSpec(args as types.GetLockSpecArgs);

    default:
      throw new Error(`${types.ACTION_KEY} cannot handle method ${method}`);
  }
};
